<template>
  <!-- Mountex.hu Footer -->
  <footer v-if="themeSite === 'mountexhu'" class="mt-[50px]">
    <div class="bg-brand-link w-full rounded-tl-[16px] rounded-tr-[16px]">
      <div class="lg:flex">
        <div class="hidden lg:flex-1 lg:flex items-end">
          <!-- Left column content -->
          <img
            src="/images/theme/mountex/footer_tree.png"
            class="max-w-[196px] h-auto"
            alt=""
            loading="lazy"
          />
        </div>
        <div class="flex-shrink-0 text-white p-4">
          <!-- Middle column content -->
          <div class="text-3xl mt-[40px] text-center font-lora font-bold">
            {{ t("newsletter_modal.title") }}
          </div>
          <div class="text-xl text-center mt-2">
            {{ t("newsletter_modal.subtitle") }}
          </div>
          <div
            class="flex flex-wrap justify-center mt-5 px-5 max-w-[530px] mx-auto"
          >
            <BaseButton
              type="footer"
              class="text-base px-[30px] lg:px-[80px] font-semibold text-white"
              @click="showSignupModal = true"
              >{{ t("i_sign_up") }}</BaseButton
            >
          </div>
        </div>
        <div class="hidden lg:flex-1 lg:flex items-center justify-center">
          <!-- Right column content -->
          <img
            src="/images/theme/mountex/footer_sun.png"
            class="max-w-[180px] h-auto"
            alt=""
            loading="lazy"
          />
        </div>
      </div>
    </div>
    <div class="bg-brand-secondary py-5">
      <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-4 container mt-5">
        <div class="px-4 text-center md:text-left">
          <div
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer md:hidden"
            @click="toggleFooterBlock('Rolunk')"
          >
            Rólunk
          </div>
          <a
            href="/rolunk/cegtortenet-filozofia"
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer hidden md:block"
          >
            Rólunk
          </a>
          <p
            id="footerRolunk"
            class="text-base font-light leading-5 hidden md:block"
          >
            <NuxtLink to="/rolunk/cegtortenet-filozofia" class="block my-3"
              >Cégtörténet, filozófia</NuxtLink
            >
            <NuxtLink to="/rolunk/torzsvasarloi-rendszer" class="block my-3"
              >Mountex tagság</NuxtLink
            >
            <NuxtLink to="/rolunk/kapcsolat" class="block my-3"
              >Kapcsolat</NuxtLink
            >
            <NuxtLink to="/rolunk/karrier" class="block my-3">Karrier</NuxtLink>
          </p>
        </div>
        <div class="px-4 text-center md:text-left">
          <div
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer md:hidden"
            @click="toggleFooterBlock('VasarlasiSegedlet')"
          >
            Vásárlási segédlet
          </div>
          <a
            href="/vasarlasi-segedlet/szallitasi-informaciok"
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer hidden md:block"
          >
            Vásárlási segédlet
          </a>
          <p
            id="footerVasarlasiSegedlet"
            class="text-base font-light leading-5 hidden md:block"
          >
            <NuxtLink
              to="/vasarlasi-segedlet/szallitasi-informaciok"
              class="block my-3"
              >Szállítási információk</NuxtLink
            >
            <NuxtLink
              to="/vasarlasi-segedlet/fizetesi-informaciok"
              class="block my-3"
              >Fizetési információk</NuxtLink
            >
            <NuxtLink to="/vasarlasi-segedlet/csere-elallas" class="block my-3"
              >Csere, elállás</NuxtLink
            >
            <NuxtLink
              to="/vasarlasi-segedlet/gyakran-ismetelt-kerdesek"
              class="block my-3"
              >GY.I.K.</NuxtLink
            >
          </p>
        </div>
        <div class="px-4 text-center md:text-left">
          <div
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer md:hidden"
            @click="toggleFooterBlock('Szolgaltatasok')"
          >
            Szolgáltatások
          </div>
          <a
            href="/szolgaltatasok"
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer hidden md:block"
          >
            Szolgáltatások
          </a>
          <p
            id="footerSzolgaltatasok"
            class="text-base font-light leading-5 hidden md:block"
          >
            <NuxtLink to="/szolgaltatasok/boulder" class="block my-3"
              >Boulder</NuxtLink
            >
            <NuxtLink to="/szolgaltatasok/javitosarok" class="block my-3"
              >Javítósarok</NuxtLink
            >
            <NuxtLink
              to="/szolgaltatasok/turatippek-applikacio"
              class="block my-3"
              >Mountex mobil app</NuxtLink
            >
            <NuxtLink to="/szolgaltatasok/ajandekkartya" class="block my-3"
              >Ajándékkártya</NuxtLink
            >
          </p>
        </div>
        <div class="px-4 text-center md:text-left">
          <div
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer md:cursor-default"
            @click="toggleFooterBlock('Ugyfelszolgalat')"
          >
            Ügyfélszolgálat
          </div>
          <div
            id="footerUgyfelszolgalat"
            class="text-base font-light leading-5 hidden md:block"
          >
            <div class="block my-3">
              E-mail: <a href="mailto:webshop@mountex.hu">webshop@mountex.hu</a>
            </div>
            <div class="block my-3">
              Telefon: <a href="tel:+3618080800">+36 1 8080 800</a>
            </div>
            <div class="block my-3">Hétfő - Péntek: 9:00 - 16:30</div>
          </div>

          <!-- social -->
          <div
            class="grid grid-cols-4 gap-1 mt-[30px] w-[232px] mx-auto sm:mx-0"
          >
            <div class="">
              <a href="https://www.facebook.com/Mountex" target="_blank">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_7112_6586)">
                    <path
                      d="M20 0C8.9544 0 0 8.9544 0 20C0 31.0456 8.9544 40 20 40C31.0456 40 40 31.0456 40 20C40 8.9544 31.0456 0 20 0ZM26.7056 11.354C26.7056 11.652 26.464 11.8936 26.1664 11.8936L23.8548 11.8944C22.2612 11.8944 21.9696 12.5156 21.9696 13.7388V16.284H26.0052C26.1484 16.284 26.286 16.3408 26.3872 16.4424C26.4884 16.5436 26.5452 16.6808 26.5452 16.824L26.5436 21.1744C26.5436 21.4724 26.302 21.714 26.004 21.714H21.9696V32.6912C21.9696 32.9892 21.728 33.2308 21.43 33.2308H16.9288C16.6308 33.2308 16.3892 32.9892 16.3892 32.6912V21.7136H12.9392C12.6412 21.7136 12.3996 21.472 12.3996 21.174V16.824C12.3996 16.526 12.6412 16.284 12.9392 16.284H16.3892V13.2816C16.3892 9.3256 18.8804 6.7696 22.7356 6.7696L26.1672 6.7752C26.4648 6.7756 26.706 7.0172 26.706 7.3148L26.7056 11.354Z"
                      fill="#B27C56"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7112_6586">
                      <rect width="40" height="40" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
            <div class="">
              <a
                href="https://www.youtube.com/@mountexmagyarorszag"
                target="_blank"
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_7112_6588)">
                    <path
                      d="M17.2871 24.0733L24.0771 19.9995L17.2871 15.9258V24.0733Z"
                      fill="#B27C56"
                    />
                    <path
                      d="M20 0C8.955 0 0 8.95375 0 20C0 31.0462 8.955 40 20 40C31.045 40 40 31.045 40 20C40 8.955 31.045 0 20 0ZM30.86 20.8763C30.86 22.7513 30.6425 24.6263 30.6425 24.6263C30.6425 24.6263 30.43 26.2238 29.78 26.925C28.9537 27.8475 28.0287 27.8525 27.6038 27.9075C24.5638 28.14 20 28.1475 20 28.1475C20 28.1475 14.3525 28.0925 12.615 27.915C12.1313 27.8188 11.0475 27.8463 10.22 26.925C9.56875 26.2225 9.3575 24.6263 9.3575 24.6263C9.3575 24.6263 9.14 22.7525 9.14 20.8763V19.1187C9.14 17.2437 9.3575 15.37 9.3575 15.37C9.3575 15.37 9.57 13.7725 10.22 13.0688C11.0462 12.145 11.9712 12.14 12.3962 12.0875C15.435 11.8525 19.995 11.8525 19.995 11.8525H20.005C20.005 11.8525 24.565 11.8525 27.6038 12.0875C28.0275 12.14 28.9537 12.145 29.78 13.0675C30.4312 13.7713 30.6425 15.3687 30.6425 15.3687C30.6425 15.3687 30.86 17.2437 30.86 19.1187V20.8763Z"
                      fill="#B27C56"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7112_6588">
                      <rect width="40" height="40" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
            <div class="">
              <a href="https://www.instagram.com/mountex/" target="_blank">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_7112_6592)">
                    <path
                      d="M28.1215 13.8569C27.9479 13.4074 27.6822 12.9993 27.3413 12.6588C27.0004 12.3182 26.592 12.0529 26.1423 11.8798C25.5232 11.6505 24.8692 11.5293 24.209 11.5215C23.1111 11.4715 22.7819 11.459 20.0007 11.459C17.2194 11.459 16.8902 11.4715 15.7923 11.5215C15.1314 11.529 14.4767 11.6503 13.8569 11.8798C13.4074 12.0534 12.9993 12.3191 12.6588 12.66C12.3182 13.0009 12.0529 13.4093 11.8798 13.859C11.6505 14.4781 11.5293 15.1321 11.5215 15.7923C11.4715 16.8902 11.459 17.2194 11.459 20.0007C11.459 22.7819 11.4715 23.1111 11.5215 24.209C11.529 24.8699 11.6503 25.5246 11.8798 26.1444C12.0534 26.5939 12.3191 27.002 12.66 27.3425C13.0009 27.6831 13.4093 27.9484 13.859 28.1215C14.4781 28.3508 15.1321 28.472 15.7923 28.4798C16.8902 28.5298 17.2194 28.5423 20.0007 28.5423C22.7819 28.5423 23.1111 28.5298 24.209 28.4798C24.8699 28.4723 25.5246 28.351 26.1444 28.1215C26.5939 27.9479 27.002 27.6822 27.3425 27.3413C27.6831 27.0004 27.9484 26.592 28.1215 26.1423C28.3508 25.5232 28.472 24.8692 28.4798 24.209C28.5298 23.1111 28.5423 22.7819 28.5423 20.0007C28.5423 17.2194 28.5298 16.8902 28.4798 15.7923C28.4723 15.1314 28.351 14.4767 28.1215 13.8569ZM20.0007 25.3507C18.9425 25.3507 17.9082 25.0369 17.0284 24.449C16.1485 23.8611 15.4628 23.0256 15.0579 22.048C14.653 21.0704 14.547 19.9947 14.7534 18.9569C14.9599 17.9191 15.4694 16.9658 16.2176 16.2176C16.9658 15.4694 17.9191 14.9599 18.9569 14.7534C19.9947 14.547 21.0704 14.653 22.048 15.0579C23.0256 15.4628 23.8611 16.1485 24.449 17.0284C25.0369 17.9082 25.3507 18.9425 25.3507 20.0007C25.3507 21.4196 24.787 22.7804 23.7837 23.7837C22.7804 24.787 21.4196 25.3507 20.0007 25.3507ZM25.5611 15.6902C25.3138 15.6902 25.0722 15.6169 24.8666 15.4796C24.661 15.3422 24.5008 15.147 24.4062 14.9186C24.3116 14.6902 24.2869 14.4388 24.3351 14.1964C24.3833 13.9539 24.5024 13.7312 24.6772 13.5564C24.852 13.3815 25.0747 13.2625 25.3172 13.2143C25.5597 13.166 25.811 13.1908 26.0394 13.2854C26.2678 13.38 26.4631 13.5402 26.6004 13.7458C26.7378 13.9513 26.8111 14.193 26.8111 14.4402C26.8111 14.7718 26.6794 15.0897 26.445 15.3241C26.2105 15.5585 25.8926 15.6902 25.5611 15.6902Z"
                      fill="#B27C56"
                    />
                    <path
                      d="M20.0003 23.4732C21.9183 23.4732 23.4732 21.9183 23.4732 20.0003C23.4732 18.0822 21.9183 16.5273 20.0003 16.5273C18.0822 16.5273 16.5273 18.0822 16.5273 20.0003C16.5273 21.9183 18.0822 23.4732 20.0003 23.4732Z"
                      fill="#B27C56"
                    />
                    <path
                      d="M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56824 3.03617 8.69181 1.52242 12.3463C0.00866565 16.0009 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9992 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C40 14.6957 37.8929 9.60859 34.1421 5.85786C30.3914 2.10714 25.3043 0 20 0ZM30.3542 24.2958C30.3363 25.1596 30.1722 26.014 29.8688 26.8229C29.6012 27.5147 29.1921 28.143 28.6676 28.6676C28.1431 29.1921 27.5148 29.6012 26.8229 29.8687C26.014 30.1722 25.1596 30.3363 24.2958 30.3542C23.1833 30.4042 22.8292 30.4167 20 30.4167C17.1708 30.4167 16.8167 30.4042 15.7042 30.3542C14.8404 30.3363 13.986 30.1722 13.1771 29.8687C12.4853 29.6012 11.857 29.1921 11.3325 28.6676C10.8079 28.143 10.3988 27.5147 10.1313 26.8229C9.82784 26.014 9.66372 25.1596 9.64584 24.2958C9.59584 23.1833 9.58334 22.8292 9.58334 20C9.58334 17.1708 9.59584 16.8167 9.64584 15.7042C9.66372 14.8404 9.82784 13.986 10.1313 13.1771C10.3988 12.4853 10.8079 11.857 11.3325 11.3324C11.857 10.8079 12.4853 10.3988 13.1771 10.1312C13.986 9.82784 14.8404 9.66371 15.7042 9.64583C16.8167 9.59583 17.1708 9.58333 20 9.58333C22.8292 9.58333 23.1833 9.59583 24.2958 9.64583C25.1596 9.66371 26.014 9.82784 26.8229 10.1312C27.5148 10.3988 28.1431 10.8079 28.6676 11.3324C29.1921 11.857 29.6012 12.4853 29.8688 13.1771C30.1722 13.986 30.3363 14.8404 30.3542 15.7042C30.4042 16.8167 30.4167 17.1708 30.4167 20C30.4167 22.8292 30.4042 23.1833 30.3542 24.2958Z"
                      fill="#B27C56"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7112_6592">
                      <rect width="40" height="40" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
            <div class="">
              <a href="https://www.tiktok.com/@mountexoutdoor" target="_blank">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_7112_6596)">
                    <path
                      d="M40 20C40 20.2182 40 20.4364 39.9792 20.6545C39.8234 25.8909 37.6006 30.6493 34.121 34.1299C30.6414 37.6104 25.4999 40 19.9948 40C19.7767 40 19.5586 40 19.3404 39.9792C8.6523 39.6364 0 30.7844 0 20C0 14.5039 2.25396 9.4961 5.87899 5.87013C9.50403 2.24416 14.5001 0 19.9948 0C25.4895 0 30.496 2.24416 34.121 5.87013C37.746 9.4961 40 14.5039 40 20Z"
                      fill="#B27C56"
                    />
                    <g style="mix-blend-mode: multiply">
                      <path
                        d="M39.9792 20.6551C39.8234 25.8915 37.6006 30.6499 34.121 34.1305C30.6414 37.611 25.4999 40.0006 19.9948 40.0006H19.3612L19.3404 39.9798C16.5983 37.2369 13.9081 34.546 11.1348 31.7824C12.5266 32.7175 14.1989 33.2577 16.0062 33.2577C20.8465 33.2577 24.7624 29.3408 24.7624 24.5097V14.8473C26.6217 16.1668 28.8964 16.9564 31.3581 16.9564V13.2266C31.8151 13.3201 32.2825 13.372 32.7499 13.372C35.087 15.8551 37.5798 18.2136 39.9792 20.6551Z"
                        fill="#FF1753"
                      />
                    </g>
                    <path
                      d="M39.9792 20.6551C39.8234 25.8915 37.6006 30.6499 34.121 34.1305C30.6414 37.611 25.4999 40.0006 19.9948 40.0006H19.3612L19.3404 39.9798C16.5983 37.2369 13.9081 34.546 11.1348 31.7824C12.5266 32.7175 14.1989 33.2577 16.0062 33.2577C20.8465 33.2577 24.7624 29.3408 24.7624 24.5097V14.8473C26.6217 16.1668 28.8964 16.9564 31.3581 16.9564V13.2266C31.8151 13.3201 32.2825 13.372 32.7499 13.372C35.087 15.8551 37.5798 18.2136 39.9792 20.6551Z"
                      fill="#B27C56"
                    />
                    <path
                      opacity="0.8"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M27.8575 11.2201C26.9019 10.1811 26.2787 8.84089 26.1437 7.35517V6.74219H24.8349C25.1673 8.62271 26.2891 10.2435 27.8575 11.2201ZM14.1884 28.0721C13.6586 27.376 13.3678 26.524 13.3678 25.6513C13.3678 23.4383 15.1647 21.6513 17.3771 21.6513C17.7926 21.6513 18.1977 21.7136 18.5924 21.8383V16.9967C18.1354 16.9344 17.668 16.9032 17.2109 16.9136V20.685C16.8162 20.5604 16.4112 20.498 15.9957 20.498C13.7833 20.498 11.9863 22.2954 11.9863 24.498C11.9863 26.0565 12.8796 27.4175 14.1884 28.0721Z"
                      fill="#FF1753"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M24.7631 14.8461C26.6223 16.176 28.9074 16.9552 31.3588 16.9552V13.2253C29.9877 12.9344 28.7724 12.2175 27.8584 11.2201C26.2899 10.2435 25.1682 8.6331 24.8358 6.74219H21.3873V25.6513C21.3873 27.8539 19.5904 29.6409 17.378 29.6409C16.0796 29.6409 14.9267 29.0175 14.1892 28.0617C12.8804 27.4071 11.9872 26.0461 11.9872 24.4876C11.9872 22.2747 13.7841 20.4876 15.9965 20.4876C16.4224 20.4876 16.8275 20.55 17.2118 20.6747V16.9032C12.465 16.9967 8.64258 20.8824 8.64258 25.6513C8.64258 28.0305 9.59817 30.1915 11.1354 31.7708C12.5273 32.7058 14.21 33.2461 16.0069 33.2461C20.8368 33.2461 24.7631 29.3292 24.7631 24.498V14.8357V14.8461Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M31.358 13.2262V12.2184C30.122 12.2184 28.9067 11.8756 27.8576 11.221C28.7925 12.2392 30.0181 12.9457 31.358 13.2262ZM24.835 6.74309C24.8039 6.56647 24.7831 6.37945 24.7623 6.20283V5.58984H19.9947V24.4989C19.9947 26.7015 18.1978 28.4885 15.9854 28.4885C15.3414 28.4885 14.7286 28.3327 14.1885 28.0626C14.9155 29.0184 16.0789 29.6418 17.3772 29.6418C19.5793 29.6418 21.3762 27.8548 21.3866 25.6522V6.74309H24.835ZM17.211 16.9041V15.834C16.8163 15.7821 16.4113 15.7509 16.0062 15.7509C11.1659 15.7509 7.25 19.6678 7.25 24.4989C7.25 27.5327 8.78726 30.2028 11.1347 31.7717C9.58706 30.1924 8.64185 28.0314 8.64185 25.6522C8.64185 20.8834 12.4642 16.9976 17.211 16.9041Z"
                      fill="#00C9D0"
                    />
                    <path
                      opacity="0.8"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M26.1439 15.9889C28.0031 17.3187 30.2882 18.098 32.7395 18.098V13.3603C32.2721 13.3603 31.8047 13.3084 31.3581 13.2148V16.9447C28.8964 16.9447 26.6217 16.1655 24.7624 14.8356V24.498C24.7624 29.3291 20.8465 33.246 16.0062 33.246C14.1989 33.246 12.5266 32.7058 11.1348 31.7707C12.724 33.3915 14.9364 34.3993 17.3981 34.3993C22.2384 34.3993 26.1542 30.4824 26.1542 25.6512V15.9889H26.1439Z"
                      fill="#FF1753"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7112_6596">
                      <rect width="40" height="40" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <br />

      <!-- copyright -->
      <div class="grid md:grid-cols-3 mt-5">
        <div class="flex gap-4 ml-5">
          <a href="/vasarlasi-segedlet/bankkartyas-fizetesi-tajekoztato">
            <img
              src="/images/partners/kh-logo.svg"
              alt="K&H Bank"
              height="42"
              width="61"
            />
          </a>
          <a href="/vasarlasi-segedlet/bankkartyas-fizetesi-tajekoztato">
            <img
              src="/images/partners/apple-pay-logo.svg"
              alt="Apple pay"
              height="42"
              width="54"
            />
          </a>
          <a href="/vasarlasi-segedlet/bankkartyas-fizetesi-tajekoztato">
            <img
              src="/images/partners/bigfish-logo.svg"
              alt="PaymentGateway.hu"
              height="42"
              width="97"
            />
          </a>
        </div>
        <div class="text-center text-xs">
          <div class="my-3">
            <a href="/impresszum">Impresszum</a> |
            <a href="/uzletszabalyzat">Üzletszabályzat</a> |
            <a href="/adatkezelesi-tajekoztato">Adatkezelési tájékoztató</a> |
            <a href="/cookie-adatkezelesi-tajekozato"
              >Süti (cookie) tájékoztató</a
            >
          </div>
          <div>
            © {{ new Date().getFullYear() }} - Mountex Kft. Minden jog
            fenntartva.
          </div>
        </div>
        <div>&nbsp;</div>
      </div>
    </div>
  </footer>

  <!-- Mountex.ro Footer -->
  <footer v-if="themeSite === 'mountexro'" class="mt-[50px]">
    <div class="bg-brand-link w-full rounded-tl-[16px] rounded-tr-[16px]">
      <div class="lg:flex">
        <div class="hidden lg:flex-1 lg:flex items-end">
          <!-- Left column content -->
          <img
            src="/images/theme/mountex/footer_tree.png"
            class="max-w-[196px] h-auto"
            alt=""
            loading="lazy"
          />
        </div>
        <div class="flex-shrink-0 text-white p-4">
          <!-- Middle column content -->
          <div class="text-3xl mt-[40px] text-center font-lora font-bold">
            {{ t("newsletter_modal.title") }}
          </div>
          <div class="text-xl text-center mt-2">
            {{ t("newsletter_modal.subtitle") }}
          </div>
          <div
            class="flex flex-wrap justify-center mt-5 px-5 max-w-[530px] mx-auto"
          >
            <BaseButton
              type="footer"
              class="text-base px-[30px] lg:px-[80px] font-semibold text-white"
              @click="showSignupModal = true"
              >{{ t("i_sign_up") }}</BaseButton
            >
          </div>
        </div>
        <div class="hidden lg:flex-1 lg:flex items-center justify-center">
          <!-- Right column content -->
          <img
            src="/images/theme/mountex/footer_sun.png"
            class="max-w-[180px] h-auto"
            alt=""
            loading="lazy"
          />
        </div>
      </div>
    </div>
    <div class="bg-brand-secondary py-5">
      <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-4 container mt-5">
        <div class="px-4 text-center md:text-left">
          <div
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer md:hidden"
            @click="toggleFooterBlock('Rolunk')"
          >
            Despre noi
          </div>
          <a
            href="/despre-noi"
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer hidden md:block"
          >
            Despre noi
          </a>
          <p
            id="footerRolunk"
            class="text-base font-light leading-5 hidden md:block"
          >
            <a href="/istoric" class="block my-3"
              >Istoria companiei, filozofie</a
            >
            <a href="/fidelizare" class="block my-3">Sistemul de fidelizare</a>
            <a href="/contact" class="block my-3">Contact</a>
          </p>
        </div>
        <div class="px-4 text-center md:text-left">
          <div
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer md:hidden"
            @click="toggleFooterBlock('VasarlasiSegedlet')"
          >
            Ghidul cumpărătorului
          </div>
          <a
            href="/informatii-utile/info-comenzi"
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer hidden md:block"
          >
            Ghidul cumpărătorului
          </a>
          <p
            id="footerVasarlasiSegedlet"
            class="text-base font-light leading-5 hidden md:block"
          >
            <a href="/informatii-utile/plata" class="block my-3"
              >Informații plată</a
            >
            <a href="/informatii-utile/transport" class="block my-3"
              >Informații livrare</a
            >
            <a href="/informatii-utile/info-schimb-renuntare" class="block my-3"
              >Schimb și renunțare</a
            >
            <a href="/informatii-utile/faq" class="block my-3"
              >Întrebări frecvente</a
            >
          </p>
        </div>
        <div class="px-4 text-center md:text-left">
          <div
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer md:hidden"
            @click="toggleFooterBlock('Szolgaltatasok')"
          >
            Servicii clienți
          </div>
          <a
            href="/contact"
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer hidden md:block"
          >
            Servicii clienți
          </a>

          <div
            id="footerSzolgaltatasok"
            class="text-base font-light leading-5 hidden md:block"
          >
            <div class="block my-3">
              E-mail: <a href="mailto:webshop@mountex.ro">webshop@mountex.ro</a>
            </div>
            <div class="block my-3">
              Telefon:
              <a href="https://wa.me/40745900467" target="_blank"
                >+4 0745 900 467</a
              >
            </div>
            <div class="block my-3 mt-5 font-bold hidden md:block">
              <a href="https://anpc.ro/" target="_blank">ANPC</a>
            </div>
          </div>
        </div>
        <div class="px-4 text-center md:text-left">
          <div
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer md:hidden"
            @click="toggleFooterBlock('Ugyfelszolgalat')"
          >
            Adresă birou retur
          </div>
          <a
            href="/contact"
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer hidden md:block"
          >
            Adresă birou retur
          </a>

          <div
            id="footerUgyfelszolgalat"
            class="text-base font-light leading-5 hidden md:block"
          >
            <div class="block my-3">400338, Cluj Napoca,</div>
            <div class="block my-3">
              <a
                href="https://maps.app.goo.gl/kaVuSxA5btoezSgu5"
                target="_blank"
                >Str Ciprian Porumbescu nr.29</a
              >
            </div>
          </div>

          <!-- social -->
          <div class="block md:hidden font-bold mt-5">
            <a href="https://anpc.ro/" target="_blank">ANPC</a>
          </div>

          <div
            class="grid grid-cols-3 gap-1 mt-[30px] w-[170px] mx-auto sm:mx-0"
          >
            <div class="">
              <a href="https://www.facebook.com/mountex.ro" target="_blank">
                <svg
                  class="mx-auto"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_7112_6586)">
                    <path
                      d="M20 0C8.9544 0 0 8.9544 0 20C0 31.0456 8.9544 40 20 40C31.0456 40 40 31.0456 40 20C40 8.9544 31.0456 0 20 0ZM26.7056 11.354C26.7056 11.652 26.464 11.8936 26.1664 11.8936L23.8548 11.8944C22.2612 11.8944 21.9696 12.5156 21.9696 13.7388V16.284H26.0052C26.1484 16.284 26.286 16.3408 26.3872 16.4424C26.4884 16.5436 26.5452 16.6808 26.5452 16.824L26.5436 21.1744C26.5436 21.4724 26.302 21.714 26.004 21.714H21.9696V32.6912C21.9696 32.9892 21.728 33.2308 21.43 33.2308H16.9288C16.6308 33.2308 16.3892 32.9892 16.3892 32.6912V21.7136H12.9392C12.6412 21.7136 12.3996 21.472 12.3996 21.174V16.824C12.3996 16.526 12.6412 16.284 12.9392 16.284H16.3892V13.2816C16.3892 9.3256 18.8804 6.7696 22.7356 6.7696L26.1672 6.7752C26.4648 6.7756 26.706 7.0172 26.706 7.3148L26.7056 11.354Z"
                      fill="#B27C56"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7112_6586">
                      <rect width="40" height="40" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
            <div class="">
              <a
                href="https://www.youtube.com/channel/UC9wi1USxQbgXHxLQ1cjY7SA"
                target="_blank"
              >
                <svg
                  class="mx-auto"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_7112_6588)">
                    <path
                      d="M17.2871 24.0733L24.0771 19.9995L17.2871 15.9258V24.0733Z"
                      fill="#B27C56"
                    />
                    <path
                      d="M20 0C8.955 0 0 8.95375 0 20C0 31.0462 8.955 40 20 40C31.045 40 40 31.045 40 20C40 8.955 31.045 0 20 0ZM30.86 20.8763C30.86 22.7513 30.6425 24.6263 30.6425 24.6263C30.6425 24.6263 30.43 26.2238 29.78 26.925C28.9537 27.8475 28.0287 27.8525 27.6038 27.9075C24.5638 28.14 20 28.1475 20 28.1475C20 28.1475 14.3525 28.0925 12.615 27.915C12.1313 27.8188 11.0475 27.8463 10.22 26.925C9.56875 26.2225 9.3575 24.6263 9.3575 24.6263C9.3575 24.6263 9.14 22.7525 9.14 20.8763V19.1187C9.14 17.2437 9.3575 15.37 9.3575 15.37C9.3575 15.37 9.57 13.7725 10.22 13.0688C11.0462 12.145 11.9712 12.14 12.3962 12.0875C15.435 11.8525 19.995 11.8525 19.995 11.8525H20.005C20.005 11.8525 24.565 11.8525 27.6038 12.0875C28.0275 12.14 28.9537 12.145 29.78 13.0675C30.4312 13.7713 30.6425 15.3687 30.6425 15.3687C30.6425 15.3687 30.86 17.2437 30.86 19.1187V20.8763Z"
                      fill="#B27C56"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7112_6588">
                      <rect width="40" height="40" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
            <div class="">
              <a href="https://www.instagram.com/mountex.ro/" target="_blank">
                <svg
                  class="mx-auto"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_7112_6592)">
                    <path
                      d="M28.1215 13.8569C27.9479 13.4074 27.6822 12.9993 27.3413 12.6588C27.0004 12.3182 26.592 12.0529 26.1423 11.8798C25.5232 11.6505 24.8692 11.5293 24.209 11.5215C23.1111 11.4715 22.7819 11.459 20.0007 11.459C17.2194 11.459 16.8902 11.4715 15.7923 11.5215C15.1314 11.529 14.4767 11.6503 13.8569 11.8798C13.4074 12.0534 12.9993 12.3191 12.6588 12.66C12.3182 13.0009 12.0529 13.4093 11.8798 13.859C11.6505 14.4781 11.5293 15.1321 11.5215 15.7923C11.4715 16.8902 11.459 17.2194 11.459 20.0007C11.459 22.7819 11.4715 23.1111 11.5215 24.209C11.529 24.8699 11.6503 25.5246 11.8798 26.1444C12.0534 26.5939 12.3191 27.002 12.66 27.3425C13.0009 27.6831 13.4093 27.9484 13.859 28.1215C14.4781 28.3508 15.1321 28.472 15.7923 28.4798C16.8902 28.5298 17.2194 28.5423 20.0007 28.5423C22.7819 28.5423 23.1111 28.5298 24.209 28.4798C24.8699 28.4723 25.5246 28.351 26.1444 28.1215C26.5939 27.9479 27.002 27.6822 27.3425 27.3413C27.6831 27.0004 27.9484 26.592 28.1215 26.1423C28.3508 25.5232 28.472 24.8692 28.4798 24.209C28.5298 23.1111 28.5423 22.7819 28.5423 20.0007C28.5423 17.2194 28.5298 16.8902 28.4798 15.7923C28.4723 15.1314 28.351 14.4767 28.1215 13.8569ZM20.0007 25.3507C18.9425 25.3507 17.9082 25.0369 17.0284 24.449C16.1485 23.8611 15.4628 23.0256 15.0579 22.048C14.653 21.0704 14.547 19.9947 14.7534 18.9569C14.9599 17.9191 15.4694 16.9658 16.2176 16.2176C16.9658 15.4694 17.9191 14.9599 18.9569 14.7534C19.9947 14.547 21.0704 14.653 22.048 15.0579C23.0256 15.4628 23.8611 16.1485 24.449 17.0284C25.0369 17.9082 25.3507 18.9425 25.3507 20.0007C25.3507 21.4196 24.787 22.7804 23.7837 23.7837C22.7804 24.787 21.4196 25.3507 20.0007 25.3507ZM25.5611 15.6902C25.3138 15.6902 25.0722 15.6169 24.8666 15.4796C24.661 15.3422 24.5008 15.147 24.4062 14.9186C24.3116 14.6902 24.2869 14.4388 24.3351 14.1964C24.3833 13.9539 24.5024 13.7312 24.6772 13.5564C24.852 13.3815 25.0747 13.2625 25.3172 13.2143C25.5597 13.166 25.811 13.1908 26.0394 13.2854C26.2678 13.38 26.4631 13.5402 26.6004 13.7458C26.7378 13.9513 26.8111 14.193 26.8111 14.4402C26.8111 14.7718 26.6794 15.0897 26.445 15.3241C26.2105 15.5585 25.8926 15.6902 25.5611 15.6902Z"
                      fill="#B27C56"
                    />
                    <path
                      d="M20.0003 23.4732C21.9183 23.4732 23.4732 21.9183 23.4732 20.0003C23.4732 18.0822 21.9183 16.5273 20.0003 16.5273C18.0822 16.5273 16.5273 18.0822 16.5273 20.0003C16.5273 21.9183 18.0822 23.4732 20.0003 23.4732Z"
                      fill="#B27C56"
                    />
                    <path
                      d="M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56824 3.03617 8.69181 1.52242 12.3463C0.00866565 16.0009 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9992 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C40 14.6957 37.8929 9.60859 34.1421 5.85786C30.3914 2.10714 25.3043 0 20 0ZM30.3542 24.2958C30.3363 25.1596 30.1722 26.014 29.8688 26.8229C29.6012 27.5147 29.1921 28.143 28.6676 28.6676C28.1431 29.1921 27.5148 29.6012 26.8229 29.8687C26.014 30.1722 25.1596 30.3363 24.2958 30.3542C23.1833 30.4042 22.8292 30.4167 20 30.4167C17.1708 30.4167 16.8167 30.4042 15.7042 30.3542C14.8404 30.3363 13.986 30.1722 13.1771 29.8687C12.4853 29.6012 11.857 29.1921 11.3325 28.6676C10.8079 28.143 10.3988 27.5147 10.1313 26.8229C9.82784 26.014 9.66372 25.1596 9.64584 24.2958C9.59584 23.1833 9.58334 22.8292 9.58334 20C9.58334 17.1708 9.59584 16.8167 9.64584 15.7042C9.66372 14.8404 9.82784 13.986 10.1313 13.1771C10.3988 12.4853 10.8079 11.857 11.3325 11.3324C11.857 10.8079 12.4853 10.3988 13.1771 10.1312C13.986 9.82784 14.8404 9.66371 15.7042 9.64583C16.8167 9.59583 17.1708 9.58333 20 9.58333C22.8292 9.58333 23.1833 9.59583 24.2958 9.64583C25.1596 9.66371 26.014 9.82784 26.8229 10.1312C27.5148 10.3988 28.1431 10.8079 28.6676 11.3324C29.1921 11.857 29.6012 12.4853 29.8688 13.1771C30.1722 13.986 30.3363 14.8404 30.3542 15.7042C30.4042 16.8167 30.4167 17.1708 30.4167 20C30.4167 22.8292 30.4042 23.1833 30.3542 24.2958Z"
                      fill="#B27C56"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7112_6592">
                      <rect width="40" height="40" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <br />

      <!-- copyright -->
      <div class="grid md:grid-cols-3 mt-5">
        <div>
          <div>
            <div class="flex gap-4 ml-5 md:justify-start justify-center">
              <a href="https://www.apple.com/apple-pay/" target="_blank">
                <img
                  src="/images/partners/apple-pay-logo.svg"
                  alt="Apple pay"
                  height="42"
                  width="54"
                />
              </a>
              <a href="https://www.paymentgateway.hu/" target="_blank">
                <img
                  src="/images/partners/bigfish-logo.svg"
                  alt="PaymentGateway.hu"
                  height="42"
                  width="97"
                />
              </a>
            </div>
          </div>
          <div class="m-2 ml-5 flex md:justify-start justify-center">
            <a href="https://worldline.com/en" target="_blank">
              <img
                src="/images/partners/worldline.png"
                alt="Wordline"
                height="24"
                width="209"
              />
            </a>
          </div>
        </div>
        <div class="text-center text-xs order-last md:order-none">
          <div class="my-3">
            <a href="/regulament">Termeni și condiții</a> |
            <a href="/procesarea-datelor-personale"
              >Procesarea datelor personale</a
            >
            | <a href="/politica-de-cookies">Politica de Cookies</a> |
            <a href="/legal">Impressum</a>
          </div>
          <div>
            © {{ new Date().getFullYear() }} Mountex SRL Toate drepturile
            rezervate | CUI RO17481464 | Nr. Reg. Com. J2005001426127
          </div>
        </div>
        <div>
          <div class="flex gap-4 md:justify-end justify-center">
            <a href="https://anpc.ro/ce-este-sal/" target="_blank">
              <img
                src="/images/partners/ro-footer-1.png"
                height="42"
                width="168"
              />
            </a>
            <a
              href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO"
              target="_blank"
            >
              <img
                src="/images/partners/ro-footer-2.png"
                height="42"
                width="170"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>

  <!-- Mountex.sk Footer -->
  <footer v-if="themeSite === 'mountexsk'" class="mt-[50px]">
    <div class="bg-brand-link w-full rounded-tl-[16px] rounded-tr-[16px]">
      <div class="lg:flex">
        <div class="hidden lg:flex-1 lg:flex items-end">
          <!-- Left column content -->
          <img
            src="/images/theme/mountex/footer_tree.png"
            class="max-w-[196px] h-auto"
            alt=""
            loading="lazy"
          />
        </div>
        <div class="flex-shrink-0 text-white p-4">
          <!-- Middle column content -->
          <div class="text-3xl mt-[40px] text-center font-lora font-bold">
            {{ t("newsletter_modal.title") }}
          </div>
          <div class="text-xl text-center mt-2">
            {{ t("newsletter_modal.subtitle") }}
          </div>
          <div
            class="flex flex-wrap justify-center mt-5 px-5 max-w-[530px] mx-auto"
          >
            <BaseButton
              type="footer"
              class="text-base px-[30px] lg:px-[80px] font-semibold text-white"
              @click="showSignupModal = true"
              >{{ t("i_sign_up") }}</BaseButton
            >
          </div>
        </div>
        <div class="hidden lg:flex-1 lg:flex items-center justify-center">
          <!-- Right column content -->
          <img
            src="/images/theme/mountex/footer_sun.png"
            class="max-w-[180px] h-auto"
            alt=""
            loading="lazy"
          />
        </div>
      </div>
    </div>
    <div class="bg-brand-secondary py-5">
      <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-4 container mt-5">
        <div class="px-4 text-center md:text-left">
          <div
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer md:cursor-default"
            @click="toggleFooterBlock('Rolunk')"
          >
            O nás
          </div>
          <p
            id="footerRolunk"
            class="text-base font-light leading-5 hidden md:block"
          >
            <a href="/o-nas/historiu-spolocnosti" class="block my-3"
              >História spoločnosti</a
            >
            <a href="/o-nas/vernostny-program" class="block my-3"
              >Členstvo v Mountexe</a
            >
          </p>
        </div>
        <div class="px-4 text-center md:text-left">
          <div
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer md:cursor-default"
            @click="toggleFooterBlock('VasarlasiSegedlet')"
          >
            Rady pred nákupom
          </div>
          <p
            id="footerVasarlasiSegedlet"
            class="text-base font-light leading-5 hidden md:block"
          >
            <a
              href="/rady-pred-nakupom/informacie-o-doruceni"
              class="block my-3"
              >Informácie o doručení</a
            >
            <a href="/rady-pred-nakupom/platobne-informacie" class="block my-3"
              >Platobné informácie</a
            >
            <a
              href="/rady-pred-nakupom/vratenie-na-vymenu-a-zrusenie"
              class="block my-3"
              >Výmena a vrátenie tovaru</a
            >
            <a href="/rady-pred-nakupom/casto-kladene-otazky" class="block my-3"
              >Často kladené otázky</a
            >
          </p>
        </div>
        <div class="px-4 text-center md:text-left">
          <div
            class="text-xl md:mb-3 font-semibold font-lora cursor-pointer md:cursor-default"
            @click="toggleFooterBlock('Szolgaltatasok')"
          >
            Zákaznícky servis
          </div>
          <div
            id="footerSzolgaltatasok"
            class="text-base font-light leading-5 hidden md:block"
          >
            <div class="block my-3">
              E-mail: <a href="mailto:webshop@mountex.sk">webshop@mountex.sk</a>
            </div>
            <div class="block my-3">
              Telefónne číslo: <a href="tel:+421949165325">+421 949 165 325</a><br/>Po-Pi 9:00-17:00
            </div>
            <div class="block my-3">P. O. Box 105, 94301 Štúrovo</div>
          </div>
        </div>
        <div class="px-4 text-center md:text-left">
          <!-- social -->
          <div class="grid grid-cols-3 gap-1 w-[182px] mx-auto sm:mx-0">
            <div class="">
              <a href="https://www.facebook.com/Mountex.sk" target="_blank">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_7112_6586)">
                    <path
                      d="M20 0C8.9544 0 0 8.9544 0 20C0 31.0456 8.9544 40 20 40C31.0456 40 40 31.0456 40 20C40 8.9544 31.0456 0 20 0ZM26.7056 11.354C26.7056 11.652 26.464 11.8936 26.1664 11.8936L23.8548 11.8944C22.2612 11.8944 21.9696 12.5156 21.9696 13.7388V16.284H26.0052C26.1484 16.284 26.286 16.3408 26.3872 16.4424C26.4884 16.5436 26.5452 16.6808 26.5452 16.824L26.5436 21.1744C26.5436 21.4724 26.302 21.714 26.004 21.714H21.9696V32.6912C21.9696 32.9892 21.728 33.2308 21.43 33.2308H16.9288C16.6308 33.2308 16.3892 32.9892 16.3892 32.6912V21.7136H12.9392C12.6412 21.7136 12.3996 21.472 12.3996 21.174V16.824C12.3996 16.526 12.6412 16.284 12.9392 16.284H16.3892V13.2816C16.3892 9.3256 18.8804 6.7696 22.7356 6.7696L26.1672 6.7752C26.4648 6.7756 26.706 7.0172 26.706 7.3148L26.7056 11.354Z"
                      fill="#B27C56"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7112_6586">
                      <rect width="40" height="40" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
            <div class="">
              <a href="https://www.youtube.com/@Mountexsk" target="_blank">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_7112_6588)">
                    <path
                      d="M17.2871 24.0733L24.0771 19.9995L17.2871 15.9258V24.0733Z"
                      fill="#B27C56"
                    />
                    <path
                      d="M20 0C8.955 0 0 8.95375 0 20C0 31.0462 8.955 40 20 40C31.045 40 40 31.045 40 20C40 8.955 31.045 0 20 0ZM30.86 20.8763C30.86 22.7513 30.6425 24.6263 30.6425 24.6263C30.6425 24.6263 30.43 26.2238 29.78 26.925C28.9537 27.8475 28.0287 27.8525 27.6038 27.9075C24.5638 28.14 20 28.1475 20 28.1475C20 28.1475 14.3525 28.0925 12.615 27.915C12.1313 27.8188 11.0475 27.8463 10.22 26.925C9.56875 26.2225 9.3575 24.6263 9.3575 24.6263C9.3575 24.6263 9.14 22.7525 9.14 20.8763V19.1187C9.14 17.2437 9.3575 15.37 9.3575 15.37C9.3575 15.37 9.57 13.7725 10.22 13.0688C11.0462 12.145 11.9712 12.14 12.3962 12.0875C15.435 11.8525 19.995 11.8525 19.995 11.8525H20.005C20.005 11.8525 24.565 11.8525 27.6038 12.0875C28.0275 12.14 28.9537 12.145 29.78 13.0675C30.4312 13.7713 30.6425 15.3687 30.6425 15.3687C30.6425 15.3687 30.86 17.2437 30.86 19.1187V20.8763Z"
                      fill="#B27C56"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7112_6588">
                      <rect width="40" height="40" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
            <div class="">
              <a href="https://www.instagram.com/mountex.sk/" target="_blank">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_7112_6592)">
                    <path
                      d="M28.1215 13.8569C27.9479 13.4074 27.6822 12.9993 27.3413 12.6588C27.0004 12.3182 26.592 12.0529 26.1423 11.8798C25.5232 11.6505 24.8692 11.5293 24.209 11.5215C23.1111 11.4715 22.7819 11.459 20.0007 11.459C17.2194 11.459 16.8902 11.4715 15.7923 11.5215C15.1314 11.529 14.4767 11.6503 13.8569 11.8798C13.4074 12.0534 12.9993 12.3191 12.6588 12.66C12.3182 13.0009 12.0529 13.4093 11.8798 13.859C11.6505 14.4781 11.5293 15.1321 11.5215 15.7923C11.4715 16.8902 11.459 17.2194 11.459 20.0007C11.459 22.7819 11.4715 23.1111 11.5215 24.209C11.529 24.8699 11.6503 25.5246 11.8798 26.1444C12.0534 26.5939 12.3191 27.002 12.66 27.3425C13.0009 27.6831 13.4093 27.9484 13.859 28.1215C14.4781 28.3508 15.1321 28.472 15.7923 28.4798C16.8902 28.5298 17.2194 28.5423 20.0007 28.5423C22.7819 28.5423 23.1111 28.5298 24.209 28.4798C24.8699 28.4723 25.5246 28.351 26.1444 28.1215C26.5939 27.9479 27.002 27.6822 27.3425 27.3413C27.6831 27.0004 27.9484 26.592 28.1215 26.1423C28.3508 25.5232 28.472 24.8692 28.4798 24.209C28.5298 23.1111 28.5423 22.7819 28.5423 20.0007C28.5423 17.2194 28.5298 16.8902 28.4798 15.7923C28.4723 15.1314 28.351 14.4767 28.1215 13.8569ZM20.0007 25.3507C18.9425 25.3507 17.9082 25.0369 17.0284 24.449C16.1485 23.8611 15.4628 23.0256 15.0579 22.048C14.653 21.0704 14.547 19.9947 14.7534 18.9569C14.9599 17.9191 15.4694 16.9658 16.2176 16.2176C16.9658 15.4694 17.9191 14.9599 18.9569 14.7534C19.9947 14.547 21.0704 14.653 22.048 15.0579C23.0256 15.4628 23.8611 16.1485 24.449 17.0284C25.0369 17.9082 25.3507 18.9425 25.3507 20.0007C25.3507 21.4196 24.787 22.7804 23.7837 23.7837C22.7804 24.787 21.4196 25.3507 20.0007 25.3507ZM25.5611 15.6902C25.3138 15.6902 25.0722 15.6169 24.8666 15.4796C24.661 15.3422 24.5008 15.147 24.4062 14.9186C24.3116 14.6902 24.2869 14.4388 24.3351 14.1964C24.3833 13.9539 24.5024 13.7312 24.6772 13.5564C24.852 13.3815 25.0747 13.2625 25.3172 13.2143C25.5597 13.166 25.811 13.1908 26.0394 13.2854C26.2678 13.38 26.4631 13.5402 26.6004 13.7458C26.7378 13.9513 26.8111 14.193 26.8111 14.4402C26.8111 14.7718 26.6794 15.0897 26.445 15.3241C26.2105 15.5585 25.8926 15.6902 25.5611 15.6902Z"
                      fill="#B27C56"
                    />
                    <path
                      d="M20.0003 23.4732C21.9183 23.4732 23.4732 21.9183 23.4732 20.0003C23.4732 18.0822 21.9183 16.5273 20.0003 16.5273C18.0822 16.5273 16.5273 18.0822 16.5273 20.0003C16.5273 21.9183 18.0822 23.4732 20.0003 23.4732Z"
                      fill="#B27C56"
                    />
                    <path
                      d="M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56824 3.03617 8.69181 1.52242 12.3463C0.00866565 16.0009 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9992 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C40 14.6957 37.8929 9.60859 34.1421 5.85786C30.3914 2.10714 25.3043 0 20 0ZM30.3542 24.2958C30.3363 25.1596 30.1722 26.014 29.8688 26.8229C29.6012 27.5147 29.1921 28.143 28.6676 28.6676C28.1431 29.1921 27.5148 29.6012 26.8229 29.8687C26.014 30.1722 25.1596 30.3363 24.2958 30.3542C23.1833 30.4042 22.8292 30.4167 20 30.4167C17.1708 30.4167 16.8167 30.4042 15.7042 30.3542C14.8404 30.3363 13.986 30.1722 13.1771 29.8687C12.4853 29.6012 11.857 29.1921 11.3325 28.6676C10.8079 28.143 10.3988 27.5147 10.1313 26.8229C9.82784 26.014 9.66372 25.1596 9.64584 24.2958C9.59584 23.1833 9.58334 22.8292 9.58334 20C9.58334 17.1708 9.59584 16.8167 9.64584 15.7042C9.66372 14.8404 9.82784 13.986 10.1313 13.1771C10.3988 12.4853 10.8079 11.857 11.3325 11.3324C11.857 10.8079 12.4853 10.3988 13.1771 10.1312C13.986 9.82784 14.8404 9.66371 15.7042 9.64583C16.8167 9.59583 17.1708 9.58333 20 9.58333C22.8292 9.58333 23.1833 9.59583 24.2958 9.64583C25.1596 9.66371 26.014 9.82784 26.8229 10.1312C27.5148 10.3988 28.1431 10.8079 28.6676 11.3324C29.1921 11.857 29.6012 12.4853 29.8688 13.1771C30.1722 13.986 30.3363 14.8404 30.3542 15.7042C30.4042 16.8167 30.4167 17.1708 30.4167 20C30.4167 22.8292 30.4042 23.1833 30.3542 24.2958Z"
                      fill="#B27C56"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7112_6592">
                      <rect width="40" height="40" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <br />

      <!-- copyright -->
      <div class="grid md:grid-cols-3 mt-5">
        <div class="flex gap-4 ml-5">
          <a href="#">
            <img
              src="/images/partners/kh-logo.svg"
              alt="K&H Bank"
              height="42"
              width="61"
            />
          </a>
          <a href="#">
            <img
              src="/images/partners/apple-pay-logo.svg"
              alt="Apple pay"
              height="42"
              width="54"
            />
          </a>
          <a href="#">
            <img
              src="/images/partners/bigfish-logo.svg"
              alt="PaymentGateway.hu"
              height="42"
              width="97"
            />
          </a>
        </div>
        <div class="text-center text-xs">
          <div class="my-3">
            <a href="/impressum">Impressum</a> |
            <a href="/vseobecne-zmluvne-podmienky"
              >Všeobecné zmluvné podmienky</a
            >
            | <a href="/ochrana-osobnych-udajov">Ochrana osobných údajov</a> |
            <a href="/nastavenia-cookie">Nastavenia cookie</a>
          </div>
          <div>
            © {{ new Date().getFullYear() }} - Mountex Všetky práva vyhradené
          </div>
        </div>
        <div>&nbsp;</div>
      </div>
    </div>
  </footer>

  <ModalNewsletterSignup
    v-if="showSignupModal"
    @close="showSignupModal = false"
  />
</template>

<script setup>
import ModalNewsletterSignup from "../Modal/ModalNewsletterSignup.vue";

// -----------------------
// composables
// -----------------------
const config = useRuntimeConfig();
const themeSite = config.public.theme.site;
const { t } = useI18n();

const showSignupModal = ref(false);

const toggleFooterBlock = (block) => {
  if (typeof window !== "undefined" && window.innerWidth < 640) {
    document.getElementById("footer" + block).classList.toggle("hidden");
  }
};
</script>

<style scoped>
.topShadow {
  -webkit-box-shadow: 0px -4px 9px rgba(50, 50, 50, 0.5);
  -moz-box-shadow: 0px -4px 9px rgba(50, 50, 50, 0.5);
  box-shadow: 0px -4px 9px rgba(50, 50, 50, 0.5);
}

footer .szabadban-szabadon {
  border-top: 1px solid #eae8e2;
  border-bottom: 1px solid #eae8e2;
  color: #eae8e2;
}

footer .separator {
  width: 80px;
  height: 1px;
  display: inline-block;
  background-color: #eae8e2;
}
</style>
